/**
 * SatinNuit Product JS v4.5
 * - AJAX Add to Cart (/cart/add.js)
 * - Variant image swap
 * - Sticky ATC (IntersectionObserver)
 * - Toast notification
 * - Exit-intent + scroll popup (cookie 7j — v4.5 fix)
 * - Tracking: AddToCart + InitiateCheckout via window.snTrack
 */
(function () {
  'use strict';

  // ─── Utility ─────────────────────────────────────────────────
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function toast(msg, duration) {
    var el = qs('#sn-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sn-toast';
      el.className = 'sn-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, duration || 3000);
  }

  // ─── Cart count update ────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        qsa('[data-cart-count], .cart-count-bubble, [x-data*="cartCount"]').forEach(function (el) {
          el.textContent = count;
          el.setAttribute('aria-label', count + ' articles dans le panier');
        });
        // Dispatch for theme cart drawers
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { count: count } }));
      })
      .catch(function () {});
  }

  // ─── AJAX Add to Cart ─────────────────────────────────────────
  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        updateCartCount();
        toast('&#10003; Ajouté au panier', 2500);

        // Try to open theme drawer if available
        var drawerBtn = qs('[data-action="open-drawer"][data-drawer="cart"], .js-drawer-open-cart, [data-cart-drawer-toggle]');
        if (drawerBtn) drawerBtn.click();

        // Dispatch event for Dawn/Spotlight themes
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { variantId: variantId } }));

        // ── Tracking AddToCart (v4.5) ──────────────────────────
        if (window.snTrack) {
          var priceAttr = qs('[data-sn-price-value]');
          var price = priceAttr
            ? parseFloat(priceAttr.getAttribute('data-sn-price-value')) / 100
            : 14.99;
          window.snTrack('AddToCart', {
            content_ids: [String(variantId)],
            content_name: document.title,
            content_type: 'product',
            value: price,
            currency: 'EUR',
            quantity: quantity || 1
          });
        }
        // ───────────────────────────────────────────────────────

        if (btn) { btn.disabled = false; btn.textContent = origText; }
      })
      .catch(function () {
        toast('Erreur — veuillez réessayer', 3000);
        if (btn) { btn.disabled = false; btn.textContent = origText; }
      });
  }

  // ─── Variant selector ─────────────────────────────────────────
  function initVariantSelector() {
    var swatches = qsa('[data-sn-swatch]');
    if (!swatches.length) return;

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        // Remove selection
        var group = sw.closest('[data-sn-swatches]');
        if (group) qsa('[data-sn-swatch]', group).forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');

        var variantId = sw.dataset.variantId;
        var price     = sw.dataset.price;
        var compare   = sw.dataset.compare;
        var available = sw.dataset.available === 'true';
        var color     = sw.dataset.color;
        var imageId   = sw.dataset.mediaId;

        // Update hidden variant input on the page form
        qsa('input[name="id"]').forEach(function (inp) { inp.value = variantId; });

        // Update color label
        var label = qs('[data-sn-color-label]');
        if (label) label.textContent = color;

        // Update price display
        var priceEl = qs('[data-sn-price]');
        if (priceEl && price) priceEl.innerHTML = price;

        // Update compare price
        var compareEl = qs('[data-sn-compare]');
        if (compareEl) { compareEl.style.display = compare ? '' : 'none'; if (compare) compareEl.innerHTML = compare; }

        // Update ATC button state
        qsa('[data-sn-atc]').forEach(function (btn) {
          btn.disabled = !available;
          btn.dataset.variantId = variantId;
          if (!available) btn.textContent = 'Épuisé';
          else if (btn.dataset.origText) btn.textContent = btn.dataset.origText;
        });

        // FIX: Sync Buy Now button variant
        qsa('[data-sn-buy-now]').forEach(function (btn) {
          btn.disabled = !available;
          btn.dataset.variantId = variantId;
        });

        // FIX: Update sticky ATC color + price
        var stickyPrice = qs('#sn-sticky-price');
        if (stickyPrice && price) stickyPrice.textContent = price;

        // Swap gallery image
        if (imageId) swapGalleryImage(imageId);

        // Update URL without reload
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  // ─── Gallery ──────────────────────────────────────────────────
  function swapGalleryImage(mediaId) {
    var slides = qsa('[data-media-id]');
    var thumbs = qsa('[data-sn-thumb]');

    slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === mediaId); });
    thumbs.forEach(function (t) {
      var active = t.dataset.mediaId === mediaId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });
  }

  function initGallery() {
    qsa('[data-sn-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { swapGalleryImage(t.dataset.mediaId); });
    });
  }

  // ─── ATC buttons ─────────────────────────────────────────────
  function initATCButtons() {
    qsa('[data-sn-atc]').forEach(function (btn) {
      if (!btn.dataset.origText) btn.dataset.origText = btn.textContent.trim();
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId || (qs('input[name="id"]') || {}).value;
        var qty = parseInt((qs('input[name="quantity"]') || {}).value || '1', 10);
        addToCart(variantId, qty, btn);
      });
    });

    // Buy Now buttons
    qsa('[data-sn-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId || (qs('input[name="id"]') || {}).value;
        var qty = parseInt((qs('input[name="quantity"]') || {}).value || '1', 10);

        // ── Tracking InitiateCheckout (v4.5) ───────────────────
        if (window.snTrack) {
          var priceAttr = qs('[data-sn-price-value]');
          var price = priceAttr
            ? parseFloat(priceAttr.getAttribute('data-sn-price-value')) / 100
            : 14.99;
          window.snTrack('InitiateCheckout', {
            content_ids: [String(variantId)],
            currency: 'EUR',
            value: price * qty,
            num_items: qty
          });
        }
        // ───────────────────────────────────────────────────────

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        }).then(function () { window.location.href = '/checkout'; });
      });
    });
  }

  // ─── Qty stepper ─────────────────────────────────────────────
  function initQtyStepper() {
    qsa('[data-sn-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = qs('input[name="quantity"]');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.snQtyBtn === 'plus') val = Math.min(val + 1, 99);
        else val = Math.max(val - 1, 1);
        input.value = val;
      });
    });
  }

  // ─── Sticky ATC ───────────────────────────────────────────────
  function initStickyATC() {
    var sticky  = qs('#sn-sticky-cta');
    var sentinel = qs('[data-sn-sticky-sentinel]');
    if (!sticky || !sentinel || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
    }, { rootMargin: '0px 0px -60px 0px' });

    observer.observe(sentinel);

    var stickyBtn = qs('#sn-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variantId = (qs('input[name="id"]') || {}).value;
        var qty = parseInt((qs('input[name="quantity"]') || {}).value || '1', 10);
        addToCart(variantId, qty, stickyBtn);
      });
    }
  }

  // ─── Color grid (homepage) ────────────────────────────────────
  function initColorGrid() {
    qsa('[data-sn-grid-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        var variantId = item.dataset.variantId;
        if (!variantId) return;
        item.classList.add('is-loading');
        item.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            updateCartCount();
            item.classList.remove('is-loading');
            item.classList.add('is-added');
            item.setAttribute('aria-busy', 'false');
            toast('&#10003; ' + (item.dataset.color || 'Article') + ' ajouté au panier', 2500);
            // Open cart drawer if available (theme native)
            var drawerBtn = qs('[data-action="open-drawer"][data-drawer="cart"], .js-drawer-open-cart, [data-cart-drawer-toggle], [aria-controls*="cart"]');
            if (drawerBtn) drawerBtn.click();
            // Reset added state after 2s
            setTimeout(function () { item.classList.remove('is-added'); }, 2500);
          })
          .catch(function () {
            item.classList.remove('is-loading');
            item.setAttribute('aria-busy', 'false');
            toast('Erreur — veuillez réessayer', 3000);
          });
      });
    });
  }

  // ─── Popup (v4.5 — cookie 7 jours) ───────────────────────────
  function snCookieGet(name) {
    return document.cookie.indexOf(name + '=1') !== -1;
  }
  function snCookieSet(name) {
    document.cookie = name + '=1; max-age=604800; path=/; SameSite=Lax';
  }

  function initPopup() {
    var popup = qs('#sn-email-popup');
    if (!popup) return;
    if (snCookieGet('sn_popup_v3')) return;

    function openPopup() {
      if (snCookieGet('sn_popup_v3')) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var inp = qs('#snp-email');
      if (inp) setTimeout(function () { inp.focus(); }, 350);
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      snCookieSet('sn_popup_v3');
    }

    // Exit intent
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 10) openPopup();
    });

    // Scroll 60%
    var scrollDone = false;
    window.addEventListener('scroll', function () {
      if (scrollDone) return;
      var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (pct >= 0.6) { scrollDone = true; setTimeout(openPopup, 600); }
    }, { passive: true });

    // Close triggers
    qsa('[data-snp-close]').forEach(function (el) { el.addEventListener('click', closePopup); });
    qs('#snp-backdrop') && qs('#snp-backdrop').addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

    // Form submit
    var form = qs('#snp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = qs('#snp-email');
        var email = emailEl ? emailEl.value.trim() : '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          var err = qs('#snp-error');
          if (err) { err.hidden = false; setTimeout(function () { err.hidden = true; }, 3000); }
          return;
        }
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '&#10003;');
        fd.append('customer[email]', email);
        fd.append('customer[tags]', 'popup-v3,email-optin');

        fd.append('customer[accepts_marketing]', 'true');

        fetch('/contact#contact_form', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).finally(function () {
          var success = qs('#snp-success-wrap');
          var formWrap = qs('#snp-form-wrap');
          if (formWrap) formWrap.hidden = true;
          if (success) success.hidden = false;
          snCookieSet('sn_popup_v3');
          setTimeout(function () {
            closePopup();
            if (window.location.pathname.indexOf('/products/') === -1) {
              window.location.href = '/products/bonnet-satin-nuit-double-couche-reversible-protege-hydrate-tous-types-de-cheveux';
            }
          }, 3000);
        });
      });
    }

    // Copy code button
    var copyBtn = qs('#snp-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard && navigator.clipboard.writeText('SN10').then(function () {
          copyBtn.textContent = '&#10003; Copié !';
          setTimeout(function () { copyBtn.textContent = 'Copier'; }, 2000);
        });
      });
    }
  }

  // ─── Pack Duo upsell ─────────────────────────────────────────
  function initUpsell() {
    var check = qs('[data-sn-upsell]');
    if (!check) return;

    var duoId = check.dataset.duoVariantId;

    check.addEventListener('change', function () {
      var isChecked = this.checked;
      qsa('[data-sn-atc]').forEach(function (btn) {
        if (isChecked) {
          if (!btn.dataset.origVariantId) btn.dataset.origVariantId = btn.dataset.variantId;
          btn.dataset.variantId = duoId;
          if (!btn.dataset.origText) btn.dataset.origText = btn.textContent.trim();
          btn.textContent = 'Ajouter le Pack Duo';
          btn.disabled = false;
        } else {
          if (btn.dataset.origVariantId) btn.dataset.variantId = btn.dataset.origVariantId;
          btn.textContent = btn.dataset.origText || 'Ajouter au panier';
        }
      });
    });
  }

  // ─── Hero carousel ────────────────────────────────────────────
  function initHeroCarousel() {
    var headlines = qsa('[data-sn-headline]');
    if (headlines.length < 2) return;

    var wrapper = qs('[data-sn-headlines]');
    var ms = wrapper ? (parseInt(wrapper.dataset.rotationMs, 10) || 4500) : 4500;
    var current = 0;

    setInterval(function () {
      headlines[current].classList.remove('is-active');
      current = (current + 1) % headlines.length;
      headlines[current].classList.add('is-active');
    }, ms);
  }

  // ─── Init on DOM ready ────────────────────────────────────────
  function init() {
    initVariantSelector();
    initGallery();
    initATCButtons();
    initQtyStepper();
    initStickyATC();
    initColorGrid();
    initPopup();
    initHeroCarousel();
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
